import { create } from "zustand";
import { fitArt, type ArtTransform } from "../lib/schedule-art/art-transform";

export type DevOverlay = { image: HTMLImageElement; transform: ArtTransform };

export const useDevOverlayStore = create<{
  overlay: DevOverlay | null;
  opacity: number;
  locked: boolean;
  hidden: boolean;
  setImage: (image: HTMLImageElement) => void;
  setTransform: (transform: ArtTransform) => void;
  setOpacity: (opacity: number) => void;
  setLocked: (locked: boolean) => void;
  setHidden: (hidden: boolean) => void;
  remove: () => void;
  restore: (overlay: DevOverlay) => void;
}>((set) => ({
  overlay: null,
  opacity: 60,
  locked: false,
  hidden: false,
  setImage: (image) => set({ overlay: { image, transform: fitArt(image) }, locked: false, hidden: false }),
  setTransform: (transform) => set((state) => (state.overlay ? { overlay: { ...state.overlay, transform } } : {})),
  setOpacity: (opacity) => set({ opacity }),
  setLocked: (locked) => set({ locked }),
  setHidden: (hidden) => set({ hidden }),
  remove: () => set({ overlay: null, locked: false, hidden: false }),
  restore: (overlay) => set({ overlay }),
}));
